var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNote = function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.02 28.417H21.97a6.29 6.29 0 006.29-6.29V10.81a6.29 6.29 0 00-6.29-6.29H10.02a6.29 6.29 0 00-6.29 6.29v11.302a6.293 6.293 0 006.29 6.304z",
    fill: "#D98800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.207 8.125a.967.967 0 01-.969-.97V3.553c0-.53.427-.969.969-.969s.969.44.969.97v3.59a.97.97 0 01-.969.982zM20.793 8.125a.967.967 0 01-.969-.97V3.553c0-.542.44-.969.969-.969.543 0 .969.44.969.97v3.59a.97.97 0 01-.969.982zM19.592 17.709h-9.584a.967.967 0 01-.969-.969c0-.53.44-.969.969-.969h9.584c.543 0 .969.44.969.969 0 .53-.427.969-.969.969zM16.001 22.5h-5.993a.967.967 0 01-.969-.968c0-.543.44-.969.969-.969H16c.543 0 .969.44.969.969 0 .53-.426.969-.969.969z",
    fill: "#D98800"
  })));
};
export default SvgNote;